const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M23.61 11.29 13.39 1.08a1 1 0 0 0-.71-.3 1 1 0 0 0-.71.3L9.22 3.83a1 1 0 0 0 0 1.39l3.14 3.37a.25.25 0 0 1 .05.27.25.25 0 0 1-.23.15H1.1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h11a.25.25 0 0 1 .23.15.25.25 0 0 1 0 .27l-3.14 3.35a1 1 0 0 0 0 1.39L12 22.93a1 1 0 0 0 1.42 0l10.19-10.22a1 1 0 0 0 0-1.42Z" fill="currentColor"></path></svg>';
export {
  a as default
};
